<template>
  <Modal
    width="400"
    :value="value"
    :title="title"
    :subtitle="subtitleText"
    :cta-text="ctaText"
    :dialog-icon="dialogIcon"
    @confirm="confirm"
    :hide-actions="hideActions"
    @cancel="cancel">
  </Modal>
</template>

<script>
  import Modal from "@/components/custom/Modal.vue";
  import { PAYMENT_PLANS } from "@/constant";

  export default {
    name: "PaywallLimitModal",
    components: {
      Modal,
    },
    props: {
      value: {
        default: false,
        type: Boolean,
      },
      title: {
        default: "",
        type: String,
      },
      ctaText: {
        default: "",
        type: String,
      },
      subtitle: {
        default: "",
        type: String,
      },
      editorSubtitle: {
        default: "",
        type: String,
      },
      agencySubtitle: {
        default: "",
        type: String,
      },
    },
    computed: {
      isAgency() {
        return this.$store.state.billing.subscription?.plan === PAYMENT_PLANS.AGENCY.name.toLowerCase();
      },
      hideActions() {
        if (this.isAgency) {
          return true;
        }

        return !this.$can("read", "billing and payments information");
      },
      subtitleText() {
        if (this.isAgency) {
          return this.agencySubtitle;
        }

        return this.$can("read", "billing and payments information") ? this.subtitle : this.editorSubtitle;
      },
      dialogIcon() {
        if (this.isAgency) {
          return "info";
        } else {
          return "danger";
        }
      },
    },
    methods: {
      confirm() {
        if (this.$can("read", "billing and payments information")) {
          this.$emit("confirm", false);
        } else {
          // Closes the modal
          this.$emit("input", false);
        }
      },
      cancel() {
        this.$emit("input", false);
      },
    },
  };
</script>

<style></style>
